import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import CustomerPaymentMethodsTable from 'src/features/paymentMethods/components/tables/CustomerPaymentMethodsTable';
import { paymentMethodsMessages } from 'src/features/paymentMethods/utils/messages';

const PaymentMethodsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(paymentMethodsMessages.paymentMethods));

        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <CustomerPaymentMethodsTable />;
};

export default PaymentMethodsLayout;
